import React from 'react'
import styles from './IconNotification.module.scss'

export default function IconNotification() {
    return <div className={styles.root} />
}
